var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-container",
                { attrs: { "grid-list-md": "" } },
                [
                  _c(
                    "div",
                    { attrs: { align: "left" } },
                    [
                      _c("v-flex", { attrs: { md12: "" } }, [
                        _c("h2", [
                          _vm._v("\n              Ingreso de SIM\n            ")
                        ])
                      ])
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c("br"),
                  _c(
                    "div",
                    { staticClass: "divContenedor" },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "fle" },
                        [
                          _c("v-combobox", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              label: "Telco *",
                              items: _vm.findFilterList({ key: "telcobaja" }),
                              "item-text": "telconame",
                              "item-value": "telcoid",
                              "error-messages": _vm.errors.collect("telco"),
                              "data-vv-name": "telco",
                              dense: ""
                            },
                            on: { change: _vm.telcoSelected },
                            model: {
                              value: _vm.telco,
                              callback: function($$v) {
                                _vm.telco = $$v
                              },
                              expression: "telco"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { staticClass: "fle" },
                        [
                          _vm.telco
                            ? _c("v-combobox", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: "Plan *",
                                  items: _vm.planOptions,
                                  "item-text": "telcoplanname",
                                  "item-value": "telcoplanid",
                                  "error-messages": _vm.errors.collect("plan"),
                                  "data-vv-name": "plan",
                                  dense: ""
                                },
                                on: { change: _vm.requiredFields },
                                model: {
                                  value: _vm.plan,
                                  callback: function($$v) {
                                    _vm.plan = $$v
                                  },
                                  expression: "plan"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { staticClass: "fle" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Destino *",
                              disabled: "",
                              required: ""
                            },
                            model: {
                              value: _vm.destino,
                              callback: function($$v) {
                                _vm.destino = $$v
                              },
                              expression: "destino"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "divContenedor" },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "fle" },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Estado", disabled: "" },
                            model: {
                              value: _vm.estado,
                              callback: function($$v) {
                                _vm.estado = $$v
                              },
                              expression: "estado"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { staticClass: "fle" },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Usuario", disabled: "" },
                            model: {
                              value: _vm.usuario,
                              callback: function($$v) {
                                _vm.usuario = $$v
                              },
                              expression: "usuario"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { staticClass: "fle" },
                        [
                          _c("DatePicker", {
                            attrs: {
                              label: "Fecha",
                              max: _vm.fechaMaxima,
                              disabled: ""
                            },
                            model: {
                              value: _vm.fecha,
                              callback: function($$v) {
                                _vm.fecha = $$v
                              },
                              expression: "fecha"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }